module.exports = __webpack_public_path__ + "static/img/doctor-welcome2.0963102.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doctor-welcome2.png
// module id = 0TvC
// module chunks = 0